import * as ScreenOrientation from "expo-screen-orientation";
import { useEffect, useState } from "react";
import { Platform } from "react-native";

const orientations = {
  0: "UNKNOWN",
  1: "PORTRAIT_UP",
  2: "PORTRAIT_DOWN",
  3: "LANDSCAPE_LEFT",
  4: "LANDSCAPE_RIGHT",
} as const;

type Orientation = (typeof orientations)[keyof typeof orientations];

export const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState<Orientation>(orientations[0]);

  useEffect(() => {
    const fetchInitialOrientation = async () => {
      try {
        const currentOrientation =
          await ScreenOrientation.getOrientationAsync();
        const resolved = orientations[currentOrientation];
        if (resolved && resolved !== "UNKNOWN") {
          setOrientation(resolved);
        }
      } catch (e) {
        console.log("Error getting initial orientation", e);
      }
    };

    fetchInitialOrientation();

    const subscription = ScreenOrientation.addOrientationChangeListener(
      (event) => {
        const resolved = orientations[event.orientationInfo.orientation];
        setOrientation(resolved);
      }
    );

    return () =>
      ScreenOrientation.removeOrientationChangeListener(subscription);
  }, []);

  const unlockOrientation = async () => {
    try {
      await ScreenOrientation.unlockAsync();
    } catch (e) {
      console.log(e);
    }
  };

  const lockOrientation = async () => {
    try {
      await ScreenOrientation.lockAsync(
        ScreenOrientation.OrientationLock.PORTRAIT
      );
    } catch (e) {
      console.log(e);
    }
  };

  return { unlockOrientation, lockOrientation, orientation };
};
